function loadTabContainer(container) {
  var allTabs = container.querySelectorAll('.tab')
  var controllers = container.querySelectorAll('.tab-control')

  for (var i = 1, len = allTabs.length; i < len; i++) {
    var tab = allTabs[i]
    tab.classList.remove('active')
  }

  function tabHandler() {
    for (var n = 0, len = controllers.length; n < len; n++) {
      var contr = controllers[n]
      contr.classList.remove('active')
    }
    for (var i = 0, len = allTabs.length; i < len; i++) {
      var tab = allTabs[i]
      tab.classList.remove('active')
    }
    var tabLocator = null
    this.classList.add('active')
    var self = this
    for (var l = 0; l < this.classList.length; l++) {
      if (self.classList[l].includes('tab-') && self.classList[l] !== 'tab-control') {
        tabLocator = self.classList[l]
      }
    }
    var tabElem = container.querySelector('[data-tab-id="' + tabLocator + '"]')
    tabElem.classList.add('active')
  }

  for (var i = 0, len = controllers.length; i < len; i++) {
    controllers[i].addEventListener('click', tabHandler, false)
  }
}

function loadSelectorContainer(container) {
  var selectorBtns = container.querySelectorAll('[data-action="selector-form"]')
  var suboptionContainers = container.querySelectorAll('.suboption-container')
  var suboptionBtns = container.querySelectorAll('[data-action="subopt"]')
  var finalSubmitBtn = container.querySelector('[data-action="submit-selection"]')

  var finalHref = '#'

  function selectorHandler(e) {
    e.preventDefault()

    for (var i = 0, len = selectorBtns.length; i < len; i++) {
      selectorBtns[i].classList.remove('btn-checked')
    }
    for (var i = 0, len = suboptionBtns.length; i < len; i++) {
      suboptionBtns[i].classList.remove('btn-checked')
    }

    finalHref = '#'

    var btn = e.currentTarget
    btn.classList.add('btn-checked')

    var targetElem = '[data-target="' + btn.dataset.trigger + '"]'
    var targetObj = container.querySelector(targetElem)
    if (!targetObj) {
      return
    }

    for (var i = 0, len = suboptionContainers.length; i < len; i++) {
      suboptionContainers[i].classList.add('hide')
    }

    targetObj.classList.remove('hide')
  }

  for (var i = 0, len = selectorBtns.length; i < len; i++) {
    selectorBtns[i].addEventListener('click', selectorHandler, false)
  }

  function suboptionHandler(e) {
    e.preventDefault()

    for (var i = 0, len = suboptionBtns.length; i < len; i++) {
      suboptionBtns[i].classList.remove('btn-checked')
    }

    var btn = e.currentTarget
    var href = btn.dataset.href

    btn.classList.add('btn-checked')
    finalHref = href

    container.querySelector('[data-target="final-submit"]').classList.remove('hide')
  }

  for (var i = 0, len = suboptionBtns.length; i < len; i++) {
    suboptionBtns[i].addEventListener('click', suboptionHandler, false)
  }
  // Work on the final countdown ---
  finalSubmitBtn.addEventListener(
    'click',
    function (e) {
      e.preventDefault()
      if (finalHref != '#') {
        gtag('event', 'survey_submit', {
          event_category: 'Bruery (Custom)',
          event_label: 'reserve_2023_survey',
          event_callback: function () {
            window.location = finalHref
          }
        })

        gtag('event', 'lp_success', {
          event_category: 'Bruery (Custom)',
          event_label: 'reserve_2023',
          event_callback: function () {
            window.location = finalHref
          }
        })
      }
    },
    false
  )
}

function loadStickyBtn(btn) {
  const cmsPageBlocks = document.querySelectorAll('.cms-page-block')
  const firstBlock = cmsPageBlocks[0]
  const lastBlock = cmsPageBlocks[cmsPageBlocks.length - 1]
  const clonedBtn = btn.cloneNode(true)

  function isVisible(el) {
    var rect = el.getBoundingClientRect()
    var viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight)
    return !(rect.bottom < 0 || rect.top - viewHeight >= 0)
  }

  clonedBtn.id = 'clonedBtn'
  clonedBtn.classList.add('sticky-button')
  document.body.insertAdjacentElement('beforeend', clonedBtn)

  document.addEventListener('scroll', () => {
    if (isVisible(firstBlock) || isVisible(lastBlock)) {
      clonedBtn.classList.remove('show')
    } else {
      clonedBtn.classList.add('show')
    }
  })
}

function loadAddlClickHandlers() {
  var rootElement = document.querySelector('body')
  rootElement.addEventListener(
    'click',
    function (e) {
      if (e.target.nodeName === 'STRONG') {
        var anchor = e.path[2] ? e.path[2] : false
        if (anchor && (anchor.classList.contains('footer-east-button') || anchor.classList.contains('footer-west-button'))) {
          gtag('event', 'lp_success', {
            event_category: 'Bruery (Custom)',
            event_label: 'reserve_2023'
          })
        }
      }
    },
    true
  )
}

document.addEventListener(
  'DOMContentLoaded',
  function () {
    var tabContainer = document.querySelector('.tabbed-content')
    if (tabContainer) {
      loadTabContainer(tabContainer)
    }

    var joinSelectorContainer = document.querySelector('.join-selector-form')
    if (joinSelectorContainer) {
      loadSelectorContainer(joinSelectorContainer)
    }

    var stickyBtn = document.querySelector('#stickyBtn')
    if (stickyBtn) {
      loadStickyBtn(stickyBtn)
    }

    loadAddlClickHandlers()
  },
  false
)
